/**
 *
 * Asynchronously loads the component for Sessions
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
